import React, { useEffect } from 'react';
import axios from 'axios';
import "./RoomChangeDecision.css";
import Header from "../../../components/Header";
import Remarks from "../../../components/Remarks/Remarks";
import useAuth from '../../../../customHooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom';
import {toast} from "react-toastify"
import { baseUrl } from '../../../../common/baseUrl';
import axiosInstance from '../../../../axiosInstance/axiosInstance';


export default function RoomChangeDecision() {

  const location = useLocation();
  const navigate = useNavigate();

  const Data = location.state?.Data || {};
  const bookingId = location.state?.bookingId || "";
  const bookedRoomId = location.state?.bookedRoomId || "";
  const userId = location.state?.userId || "";
  const status = location.state?.status || "";
  const hotelId = location.state?.hotelId || "";
  const requestId = location.state?.requestId || "";


  // Accept Fee
  const handleAcceptFee = async()=>{
    try{
      const response = await axiosInstance.put(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/room-change-request/user-verdict?guest_request_id=${requestId}`,{
        accepted_by_guest : true
      }); 

      // console.log("Fee Accepted : ",response.data);
      toast.success("Fee Accepted For Room Change Request");
      navigate("/bookings",{state : {activeRequests : "requests"}})

    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");      
      console.log(error);
    }
  }

  // Reject Fee
  const handleRejectFee = async()=>{
    try{
      const response = await axiosInstance.put(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/room-change-request/user-verdict?guest_request_id=${requestId}`,
      {
        accepted_by_guest : false
      }); 

      // console.log("Fee Rejected : ",response.data);
      toast.success("Fee Rejected For Room Change Request");
      navigate("/bookings",{state : {activeRequests : "requests"}})

    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
  }


  // Refresh Handle
  useAuth();

  // Check Id Are there or not
  useEffect(()=>{
    const checkId = ()=>{
      if(bookingId==="" || bookedRoomId==="" || hotelId===""){
        navigate("/bookings");
      }
    }
    checkId();
  },[]);


  // Close Request
  const closeRequest = async()=>{
    try{
      const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${requestId}/close`);
      // console.log("Request Cancelled : ",response.data);
      toast.success("Room Change Request Cancelled Successfully");
      navigate("/bookings",{state : {activeRequests : "requests"}});
    }catch(error){
      toast.error(error?.response?.data?.message || "Some Error Occured");
      console.log(error);
    }
  }
  



  return (
    <div className='roomChangeDecision'>
      <Header title="Change Room" />

      <div className='roomChangeDecision-view'>
        
        {/* Reason */}
        <div className='roomChangeDecision-data'>
          <h4>Reason</h4>
          <div className='roomChangeDecision-comment'>
            <h5>{Data.reason}</h5>
          </div>
        </div>

        {/* Specification */}
        {Data.room_specification && 
          <div className='roomChangeDecision-data'>
            <h4>Room specification & Additional comments</h4>
            <div className='roomChangeDecision-comment'>
              <h5>{Data.room_specification}</h5>
            </div>
          </div>
        }

        {/* Price Quoted */}
        {Data.total_amount!=0 && Data.total_amount!=null &&
          <div className='roomChangeDecision-data'>
            <h4>Price Quoted by Hotel</h4>
            <div className='roomChangeDecision-inp'>
              <h5>₹{Data.total_amount}</h5>
            </div>
          </div>
        }


        {Data.total_amount===0 && 
          <div className='roomChangeDecision-data'>
            <h4>Price Quoted by Hotel</h4>
            <div className='roomChangeDecision-inp'>
              <h5>₹{Data.total_amount}</h5>
            </div>
          </div>
        }



        {/* New Room */}
        {Data.new_room && 
          <div className='roomChangeDecision-data'>
            <h4>New Room#</h4>
            <div className='roomChangeDecision-inp'>
              <h5>{Data.new_room}</h5>
            </div>
          </div>
        }


      </div>

      {/* Remarks */}
      {
      Data.remarks && 
        <Remarks para={Data.remarks}/>
      }

      {/* Room Change Btn */}
      {
        (Data.status === "Completed_Hotel" || Data.status === "Completed_Guest" || 
        Data.status === "Declined_Guest" || Data.status === "Declined_Hotel" || 
        Data.status === "Closed_Guest" || Data.status === "Pending_Hotel") 
          ? null  // Render nothing
          : (Data.status === "Pending_Guest") ? (
            <div className='roomChangeDecision-btn'>
              <div className="reject-btn">
                <button onClick={handleRejectFee}>Reject Fee</button>
              </div>
              <div className="accept-btn">
                <button onClick={handleAcceptFee}>Accept Fee</button>
              </div>
            </div>
          ) : null  // Handle case where `Pending_Guest` is not true
      }

      {
        (Data.status==="Pending_Hotel" || Data.status==="Scheduled_Hotel" || Data.status==="InProgress_Hotel") && 
        (
          <div className="roomChange-cancel-btn">
            <button onClick={closeRequest}>Cancel Request</button>
          </div>
        )
      }


    
    </div>
  )
}
